import { QueryObserverOptions, useQuery } from "react-query";
import { APIError, APIResponse, API_URL_V3, get } from "../api";
import { BillNetwork } from "./useBillAirtimeProviders";

/**
 * Data networks from the provider-agnostic bills layer (/v3/bills).
 */
function useBillDataProviders(
  options?: QueryObserverOptions<APIResponse<BillNetwork[]>, APIError>
) {
  const {
    data: providers,
    isLoading: fetchingProviders,
    isError: isProvidersError,
    error: providersError,
  } = useQuery<APIResponse<BillNetwork[]>, APIError>(
    "bills-data-providers",
    async () =>
      await get(API_URL_V3 + "/bills/data/providers", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }),
    options
  );

  return {
    providers: providers?.data || [],
    fetchingProviders,
    isProvidersError,
    providersError,
  };
}

export default useBillDataProviders;
